var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5V0H1.5C0.66875 0 0 0.66875 0 1.5V30.5C0 31.3312 0.66875 32 1.5 32H22.5C23.3312 32 24 31.3312 24 30.5V10H15.5C14.675 10 14 9.325 14 8.5ZM18 23.25C18 23.6625 17.6625 24 17.25 24H6.75C6.3375 24 6 23.6625 6 23.25V22.75C6 22.3375 6.3375 22 6.75 22H17.25C17.6625 22 18 22.3375 18 22.75V23.25ZM18 19.25C18 19.6625 17.6625 20 17.25 20H6.75C6.3375 20 6 19.6625 6 19.25V18.75C6 18.3375 6.3375 18 6.75 18H17.25C17.6625 18 18 18.3375 18 18.75V19.25ZM18 14.75V15.25C18 15.6625 17.6625 16 17.25 16H6.75C6.3375 16 6 15.6625 6 15.25V14.75C6 14.3375 6.3375 14 6.75 14H17.25C17.6625 14 18 14.3375 18 14.75ZM24 7.61875V8H16V0H16.3813C16.7812 0 17.1625 0.15625 17.4438 0.4375L23.5625 6.5625C23.8438 6.84375 24 7.225 24 7.61875Z",
    fill: ""
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Report.ce29996245fdfb3183510c06906a64ba.svg";